<svelte:options runes={true} />

<script lang="ts">
  import type { CommandManager } from '@commands';
  import { CommandId, setPendingLocale } from '@commands';
  import type { Doc } from '@doc';
  import type { KeyManager } from '@reactive';
  import type { MenuSelectEventDetail } from '@shoelace-style/shoelace/dist/components/menu/menu.component.js';
  import { Locale, LocaleId, StringId } from '@strings';

  let {
    keyManager,
    doc = $bindable(),
    commandManager
  }: { keyManager: KeyManager; doc: Doc; commandManager: CommandManager } = $props();

  function handleSelect(event: CustomEvent<MenuSelectEventDetail>) {
    const value = event.detail.item.value as LocaleId;
    setPendingLocale(value);
    commandManager.dispatch(CommandId.SET_LOCALE);
  }

  let checkedState = $derived.by(() => {
    const localeId = doc.locale;
    const result: Record<string, boolean> = {};
    for (const id of Object.values(LocaleId)) {
      result[id] = id === localeId;
    }
    return result;
  });

  let itemName = $derived.by(() => {
    const result: Record<string, string> = {};
    for (const localeId of Object.values(LocaleId)) {
      const symbol = Locale.localizedString(StringId.LOCALE_SYMBOL, localeId);
      const name = Locale.localizedString(StringId.LOCALE_NAME, localeId);
      result[localeId] = `${symbol} ${name}`;
    }
    return result;
  });

  let itemNote = $derived.by(() => {
    const result: Record<string, string> = {};
    for (const id of Object.values(LocaleId)) {
      result[id] = keyManager.alt ? id : '';
    }
    return result;
  });
</script>

<div class="dropdown-selection">
  <sl-dropdown>
    <sl-button slot="trigger" caret size="small">
      {Locale.localizedString(StringId.LOCALE_SYMBOL, doc.locale)}
      {Locale.localizedString(StringId.LOCALE_NAME, doc.locale)}
    </sl-button>
    <sl-menu onsl-select={handleSelect} value={doc.locale}>
      {#each Object.values(LocaleId) as localeId}
        <sl-menu-item checked={checkedState[localeId]} type="checkbox" value={localeId}>
          <div style="display: flex; flex-direction: row; align-items: center;">
            <div>{itemName[localeId]}</div>
            <div style="width: 10px;"></div>
            <div class="fl-note">{itemNote[localeId]}</div>
          </div>
        </sl-menu-item>
      {/each}
    </sl-menu>
  </sl-dropdown>
</div>
